var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedinFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.425,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.367 18v-7.226a.766.766 0 00-.3-.525 1.4 1.4 0 00-1 0l-1 .525V18m-4.058 0V5.964h4.058V6.7a5.246 5.246 0 013.988-.035l.07.035a4.817 4.817 0 012.291 4.076V18M4.399 18H.4V5.964h4.04zM2.414 4.809A2.386 2.386 0 010 2.448v-.053A2.377 2.377 0 012.343 0H2.4a2.427 2.427 0 012.466 2.4v.017a2.412 2.412 0 01-2.449 2.4z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/linkedin_full.74f68ca297b981ccabc3f19a849267e5.svg";
export { SvgLinkedinFull as ReactComponent };